import React, { useState, useEffect, useCallback } from "react";
import { TextField, Grid } from "@mui/material";
import ngeohash from "ngeohash";
import { GeoPoint } from "firebase/firestore";
import debounce from "lodash/debounce";
import { loadGoogleMaps } from "../utils/googleMapsLoader";

const QTDetailsLatLongSection = ({
  label,
  value,
  latValue,
  longValue,
  onChange,
  disabled,
  editEnabled,
}) => {
  const [latLongInput, setLatLongInput] = useState(
    `${latValue + "," + longValue}`
  );

  useEffect(() => {
    setLatLongInput(`${latValue + "," + longValue}`);
  }, [latValue, longValue]);

  useEffect(() => {
    let cancelled = false;

    // Only the (non-deprecated) Geocoder is used here; no Places service is
    // needed, we just need the API present before geocoding.
    loadGoogleMaps()
      .then(() => {
        if (cancelled) return;
      })
      .catch((error) => {
        if (cancelled) return;
        console.error("Google Maps failed to load:", error);
      });

    return () => {
      cancelled = true;
    };
  }, []);

  const fetchPlaceDetailsFromLatLong = useCallback(
    debounce((latitude, longitude) => {
      if (!window.google?.maps?.Geocoder) {
        console.error(
          "Google Maps Geocoder is unavailable; cannot resolve lat/long."
        );
        return;
      }
      const geocoder = new window.google.maps.Geocoder();
      const latLng = new window.google.maps.LatLng(latitude, longitude);

      geocoder.geocode({ location: latLng }, (results, status) => {
        if (status === window.google.maps.GeocoderStatus.OK && results[0]) {
          const address = results[0].formatted_address;
          const geoPoint = new GeoPoint(latitude, longitude);
          const geohash = ngeohash.encode(latitude, longitude);
          // Extract city, state, and country
          const addressComponents = results[0].address_components;
          let city = "";
          let state = "";
          let country = "";
          let label = false; // Use the name field as the label if available
          // let label = results[0].name || false; // Use the name field as the label if available

          addressComponents.forEach((component) => {
            if (
              component.types.includes("point_of_interest") &&
              component.types.includes("establishment")
            ) {
              label = results[0].name;
            }
            if (component.types.includes("locality")) {
              city = component.long_name;
            }
            if (
              component.types.includes("administrative_area_level_1") &&
              component.types.includes("political")
            ) {
              state = component.long_name;
            }
            if (component.types.includes("country")) {
              country = component.long_name;
            }
          });

          console.log("addressComponents::", addressComponents);
          console.log("citycity::", city);
          console.log("state::", state);
          console.log("country::", country);
          console.log("label::", label);
          // console.log("place::", place);

          // const locationDisplay = label
          //   ? `${label}, ${city}, ${state}`
          //   : `${city}, ${state}`;
          // const locationDisplay =
          //   label && city && state
          //     ? `${label}, ${city}, ${state}`
          //     : city && state
          //     ? `${city}, ${state}`
          //     : "";

          const locationDisplay =
            label && city && state
              ? `${label}, ${city}, ${state}`
              : city && state
              ? `${city}, ${state}`
              : "";

          console.log("locationDisplay::", locationDisplay);

          const locationData = {
            location: address,
            locationDisplay: locationDisplay, // city and state
            // locationDisplay: `${city}, ${state}`, // city and state
            locationCountry: country,
            coordinates: geoPoint,
            g: {
              geohash,
              geopoint: geoPoint,
            },
          };
          onChange(locationData);
        } else {
          console.error("Error fetching place details:", status);
        }
      });
    }, 500),
    [onChange]
  );

  const handleLatLongInputChange = (e) => {
    setLatLongInput(e.target.value);
    const [latitude, longitude] = e.target.value.split(",").map(Number);
    if (!isNaN(latitude) && !isNaN(longitude)) {
      fetchPlaceDetailsFromLatLong(latitude, longitude);
    }
  };

  return (
    <Grid container alignItems={"center"} style={{ marginBottom: 24 }}>
      <span style={titleTextStyle}>{label}</span>
      <TextField
        variant="outlined"
        placeholder="Latitude, Longitude"
        value={latLongInput}
        // defaultValue={value}
        onChange={handleLatLongInputChange}
        sx={{
          width: "70%",
          "& .MuiInputBase-input.Mui-disabled": {
            WebkitTextFillColor: "#000000",
          },
          marginTop: "0px",
        }}
        InputProps={{
          sx: {
            ...textfieldSXStyles,
            backgroundColor: editEnabled ? "#D2D2D2" : "#FFFFFF",
            color: "#515563",
          },
        }}
        disabled={editEnabled ? false : disabled}
      />
    </Grid>
  );
};

export default QTDetailsLatLongSection;

const titleTextStyle = {
  width: "25%",
  color: "#020303",
  fontSize: 14,
  fontWeight: 700,
  fontFamily: "Avenir Book, sans-serif",
};

const textfieldSXStyles = {
  height: 40,
  border: "none",
  borderColor: "#7676801F",
  color: "#515563",
  fontSize: 14,
  fontWeight: 500,
  fontFamily: "Avenir Book, sans-serif",
};
